import axios from 'axios';

const fetchData = async () => {
  try {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    //const apiBaseUrl = 'http://localhost:3001';


    //ändra "apiBaseUrl" nedan till localhost:3001 när ni testar lokalt
    const teachersResponse = await axios.get(`${apiBaseUrl}/api/teachers`);
    const teachers = teachersResponse.data;

    const queryParams = teachers
      .map((teacher) => `s.${teacher.id}`)
      .join('%2C');

    //ändra "apiBaseUrl" nedan till localhost:3001 när ni testar lokalt
    const scheduleUrl = `${apiBaseUrl}/schedule/${queryParams}`;

    const scheduleResponse = await axios.get(scheduleUrl);
    const scheduleData = scheduleResponse.data;

    return { teachers, scheduleData };
  } catch (error) {
    console.error('Error fetching schedule:', error);
    throw error;
  }
};

export default fetchData;
